export enum TaskStatus {
  ACTIVE = 'active',
  FINISHED = 'done',
}
